import React, { FC, ReactNode } from "react";
import { Heading } from "@telia/teddy";

interface OrderDetailSectionProps {
    children: ReactNode;
    title?: string;
}

const OrderDetailSection: FC<OrderDetailSectionProps> = ({ title, children }) => (
    <section className="order-detail__section">
        {title && (
            <Heading as="h2" variant="title-100" mb="200">
                {title}
            </Heading>
        )}
        {children}
    </section>
);

export default OrderDetailSection;
